import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=879441c0&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=879441c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879441c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('879441c0')) {
      api.createRecord('879441c0', component.options)
    } else {
      api.reload('879441c0', component.options)
    }
    module.hot.accept("./userDetails.vue?vue&type=template&id=879441c0&scoped=true", function () {
      api.rerender('879441c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/userDetails.vue"
export default component.exports